import React, {useState} from 'react';
import {useStores} from "../../stores/Context";
import WidgetConsignesBtn from "./SidebarWidgetsActionBtn/WidgetConsignesBtn";
import {observer} from "mobx-react";
import WidgetIndicateursBtn from "./SidebarWidgetsActionBtn/WidgetIndicateursBtn";
import WidgetMessagesInterServices from "./SidebarWidgetsActionBtn/WidgetMessagesInterServices";
import WidgetPlanningActionsBtn from "./SidebarWidgetsActionBtn/WidgetPlanningActionsBtn";
import WidgetTableauBlancBtn from "./SidebarWidgetsActionBtn/WidgetTableauBlancBtn";
import WidgetBibliothequeImageBtn from "./SidebarWidgetsActionBtn/WidgetBibliothequeImageBtn";
import WidgetRSPBtn from "./SidebarWidgetsActionBtn/WidgetRSPBtn";
import BibliothequeImagesModule from "../Widgets/WidgetBibliothequeImages/ModuleSidebar/BibliothequeImagesModule";
import WidgetBibliothequeImagesSvg from "../../boiteAOutils/SVG/TypeWidget/WidgetBibliothequeImagesSvg";

const SidebarWidgets = observer(({widget, children}) => {
    const {bibliothequeImagesStore, sidebarWidgetStore} = useStores();
    const [openSidebar, setOpenSidebar] = useState(false);

    const handleMenuClose = () => {
        sidebarWidgetStore.handleCloseSidebarWidget()
    }

    const handleMenuOpen = () => {
        sidebarWidgetStore.handleOpenSidebarWidget()
    }

    return (
        sidebarWidgetStore.openSidebarWidget ? (
            <div className={"widgetsNav"}>

                <div className={"widgetsNavBar slide-right"}>
                    <div className={"container_svg_phidget"}>
                        {
                            widget === "consignes" ? (
                                <svg style={{width: "3em"}} viewBox="0 0 40 40" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <g opacity="0.4">
                                        <path d="M11 8L7 8V37H33V8L29 8" stroke="#FBFDFE" strokeWidth="4"/>
                                        <rect x="13" y="4" width="14" height="8" stroke="#FBFDFE" strokeWidth="4"/>
                                    </g>
                                </svg>
                            ) : widget === "messagesInterService" ? (
                                <svg style={{width: "3em"}} viewBox="0 0 38 34" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2 5.66797H36V29.7513H2V5.66797Z" stroke="#FBFDFE" strokeWidth="4"
                                          strokeLinejoin="round"/>
                                    <path d="M4.15137 5.66797H33.9381L19.0001 21.2513L4.15137 5.66797Z" stroke="#FBFDFE"
                                          strokeWidth="4" strokeLinejoin="round"/>
                                </svg>
                            ) : widget === "PlanningActions" ? (
                                <svg style={{width: "3em"}} viewBox="0 0 40 40" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <g opacity="0.4">
                                        <path d="M8 13H32V31.9986C32 34.7613 29.7619 37 27 37H8V13Z" stroke="#FBFDFE"
                                              strokeWidth="4" strokeMiterlimit="10"/>
                                        <path d="M24 37V29H32" stroke="#FBFDFE" strokeWidth="4" strokeMiterlimit="10"/>
                                        <path d="M19.9989 17.8527L24.7528 7.48928" stroke="#FBFDFE" strokeWidth="3"
                                              strokeMiterlimit="10"/>
                                        <path
                                            d="M26 8C27.6569 8 29 6.65685 29 5C29 3.34315 27.6569 2 26 2C24.3431 2 23 3.34315 23 5C23 6.65685 24.3431 8 26 8Z"
                                            stroke="#FBFDFE" strokeWidth="3" strokeMiterlimit="10"/>
                                    </g>
                                </svg>
                            ) : widget === "indicateurs" ? (
                                <svg style={{width: "3em"}} xmlns="http://www.w3.org/2000/svg" width="50" height="50"
                                     viewBox="0 0 40 40" fill="none">
                                    <path
                                        d="M18.2689 8.33203C10.9465 8.36681 5 14.3134 5 21.6654C5 29.0174 10.9813 34.9987 18.3333 34.9987C25.6634 34.9987 31.6319 29.0522 31.6667 21.7298"
                                        stroke="white" strokeWidth="4"/>
                                    <path d="M22 18.3314V4.99805C29.3367 5.03318 35.2982 10.9947 35.3333 18.3314H22Z"
                                          stroke="white" strokeWidth="4"/>
                                </svg>
                            ) : widget === "TableauBlanc" ? (
                                <svg width="36" height="28" viewBox="0 0 36 28" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M6 0H30C32.1875 0 34 1.8125 34 4V22H30V4H6V22H2V4C2 1.8125 3.75 0 6 0ZM14 22C14 20.9375 14.875 20 16 20H24C25.0625 20 26 20.9375 26 22V24H34C35.0625 24 36 24.9375 36 26C36 27.125 35.0625 28 34 28H2C0.875 28 0 27.125 0 26C0 24.9375 0.875 24 2 24H14V22Z"
                                        fill="#FBFDFE"/>
                                </svg>


                            ) : widget === "photos" ? (
                                <WidgetBibliothequeImagesSvg width={60} height={60} />
                            ) : null
                        }
                    </div>

                    <div className={"widgetsNavBarContentSeparateur"}>
                        <svg style={{width: "5em"}} viewBox="0 0 84 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 2H82" stroke="#00B0FF" strokeWidth="4" strokeLinecap="round"/>
                        </svg>
                    </div>


                    {
                        widget === "consignes" ? (
                            <WidgetConsignesBtn/>
                        ) : widget === "indicateurs" ? (
                            <WidgetIndicateursBtn/>
                        ) : widget === "messagesInterService" ? (
                            <WidgetMessagesInterServices/>
                        ) : widget === "PlanningActions" ? (
                            <WidgetPlanningActionsBtn/>
                        ) : widget === "TableauBlanc" ? (
                            <WidgetTableauBlancBtn children={children}/>
                        ) : widget === 'RSP' ? (
                            <WidgetRSPBtn/>
                        ) : widget === 'photos' ? (
                            <WidgetBibliothequeImageBtn/>
                        ) : null
                    }
                </div>

                <div className={"widgetsNavBarCloseBtn"} onClick={handleMenuClose}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 5L15.6452 15.6452" stroke="#002335" strokeWidth="2" strokeLinecap="round"
                              strokeLinejoin="round"/>
                        <path d="M5 15.6445L15.6452 4.99937" stroke="#002335" strokeWidth="2" strokeLinecap="round"
                              strokeLinejoin="round"/>
                    </svg>
                </div>

                {
                    bibliothequeImagesStore.openModuleImage ? (
                        <BibliothequeImagesModule/>
                    ) : null
                }

            </div>

        ) : (
            <div className={"widgetsNavBarCloseOpen"} onClick={handleMenuOpen}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 4.16699L13.3026 9.96964L7.5 15.7723" stroke="#002335" strokeWidth="2"/>
                </svg>
            </div>
        )
    );
});

export default SidebarWidgets;
